// export const textTruncate = function(str: string) {
//     let length = 20;
//     if (str.length > length) {
//         return str.substring(0, length) + '...';
//     } else {
//         return str;
//     }
// };

export function textTruncate(str: string, truncationIndicator = "...") {
    let maxLength = 20;
    if (str.length <= maxLength) {
      return str;
    }
    return str.slice(0, maxLength - truncationIndicator.length) + truncationIndicator;
  }
